module.exports = __webpack_public_path__ + "img/d.3de623b0.jpg";